import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { SectionHeading } from '../product/SectionHeading';
import { ProductVisualView } from '../product/ProductVisualView';
import { productCatalog } from '../../data/products/shared';
import type { SolutionHelp } from '../../types/solution';
type HelpRowsProps = {
  items: SolutionHelp[];
};
export function HelpRows({
  items
}: HelpRowsProps) {
  return <section className="w-full bg-white pb-20" aria-labelledby="helps-heading" data-id="element-1494" data-mp="n1bep47iulv5">
      <div className="mx-auto max-w-shell px-6" data-id="element-1495" data-mp="i39welhx6qkq">
        <SectionHeading id="helps-heading" title="How Kayko helps" subtitle="Each problem, solved by a part of Kayko you can start using today." data-id="element-1496" data-mp="wsz8vcvgqh0b" />
        <div className="mt-14 space-y-16 lg:space-y-8" data-id="element-1497" data-mp="rw8km29i8f3t">
          {items.map((item, index) => {
          const product = productCatalog[item.product];
          const ProductIcon = product?.icon;
          const visualFirst = index % 2 === 0;
          return <article key={item.title} className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-16" data-id="element-1498" data-mp="z2nvqzzd9b0s" data-mpi={index}>
                <div className={`flex min-h-[340px] items-center justify-center rounded-[16px] bg-canvas-lilac px-6 py-10 sm:px-10 ${visualFirst ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-1499" data-mp="142a8z9f72r9l">
                  <ProductVisualView visual={item.visual} className="flex w-full justify-center" data-id="element-1500" data-mp="1i0qn3lfdzk1r" />
                </div>
                <div className={`max-w-[460px] ${visualFirst ? 'lg:order-2' : 'lg:order-1 lg:justify-self-end'}`} data-id="element-1501" data-mp="1mxqtxyk28qtx">
                  <p className="text-[13px] font-medium text-ink-muted" data-id="element-1502" data-mp="1rqjz2njfy16j">
                    Solves: <span className="text-ink" data-id="element-1503" data-mp="1wnjywgpp67p7">“{item.solves}”</span>
                  </p>
                  <h3 className="display mt-3 text-[26px] font-semibold text-ink sm:text-[30px]" data-id="element-1504" data-mp="21p98rt16ofbp">{item.title}</h3>
                  <p className="mt-4 text-[16px] leading-[1.6] text-ink-muted" data-id="element-1505" data-mp="25q2uqgv2fk1y">{item.copy}</p>
                  {product && <SmartLink href={product.href} className="group mt-6 inline-flex items-center gap-2 rounded-full border border-canvas-line bg-white py-1.5 pl-2 pr-3.5 text-[13.5px] font-medium text-ink transition-colors duration-150 ease-out hover:border-brand/40" data-id="element-1506" data-mp="6if7yk1b9kiu">
                      {ProductIcon && <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-soft text-brand" data-id="element-1507" data-mp="p9g7b96cfi2x">
                          <ProductIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-1508" data-mp="kekazwu2q8k0" />
                        </span>}
                      <span className="text-ink-muted" data-id="element-1509" data-mp="ubp28b2s0u7o">Uses:</span> {product.title}
                      <ArrowRightIcon className="h-3.5 w-3.5 text-brand transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1510" data-mp="302kfyxjajmq7" />
                    </SmartLink>}
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}